module.exports = __webpack_public_path__ + "static/media/dublin-express-logo-header.599c6cbb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dublin-express/dublin-express-logo-header.svg
// module id = 161
// module chunks = 0